import React, { useEffect, useState, createElement, Component } from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { ContactSection } from '../components/ContactSection';
import { UtmCapture } from '../components/UtmCapture';
import { EventsLeadForm } from '../components/EventsLeadForm';
import { getUtmParams } from '../utils/utmTracking';
import { motion } from 'framer-motion';
import { Calendar, Users, Gift, Sparkles, Coffee, Utensils, Waves, Droplets, Heart, Wine, Smile, Send, CheckCircle2 } from 'lucide-react';
const ourEvents = [{
  title: 'ימי גיבוש לחברות',
  description: 'יום מלא של פעילויות ימיות, משחקי קבוצה ובניית צוות. חוויה שתחזק את הקשרים בצוות ותיצור זיכרונות משותפים.',
  image: 'https://cdn.magicpatterns.com/uploads/6eVwxnd5NhVtYfdQz83Mv5/חברות.jpg',
  color: 'from-blue-500 to-cyan-400',
  link: '/team-building'
}, {
  title: 'בוקר גברים על המים',
  description: 'חותרים, אוכלים, שותים ומדברים על החיים. יום אחד לצאת מהשגרה, להזיע, לצחוק הרבה ולדבר באמת.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/ef1b0b23-2287-46ee-a83c-012851ba9107.jpg',
  color: 'from-slate-700 to-amber-500',
  link: '/mens-morning-on-water'
}, {
  title: 'אירועים משפחתיים',
  description: 'ימי הולדת, בר/בת מצווה, מסיבות משפחתיות ואירועים מיוחדים. יום בלתי נשכח לכל המשפחה על חוף הכנרת.',
  image: 'https://cdn.magicpatterns.com/uploads/9X5FNE8zK66yqawi4si15S/GetAttachmentThumbnail_(1).jpg',
  color: 'from-pink-500 to-rose-400'
}, {
  title: 'סדנאות קונספט',
  description: 'בוקר נשי, מסיבת רווקות או סתם מפגש חברים. חוויה מיוחדת שמחברת בין ים, רוגע וחברות טובה.',
  image: 'https://cdn.magicpatterns.com/uploads/2qPvWfrpuA9zC4zk67VF34/cf6f08e4-6b6e-4138-add5-a6c3e0976860_(1).jpg',
  color: 'from-purple-500 to-pink-400'
}];
const eventIncludes = [{
  icon: Utensils,
  title: 'ארוחות לבחירה',
  description: 'ממגוון תפריטים מותאמים אישית',
  image: 'https://cdn.magicpatterns.com/uploads/9K1K7Y8duPn8u1ZWuc6RZi/IMG_7629.jpg'
}, {
  icon: Waves,
  title: 'שימוש חופשי בציוד חתירה',
  description: 'כל ציוד המועדון והדרכה בסיסית',
  image: 'https://cdn.magicpatterns.com/uploads/uL5iLVfpHFdEsjuc5CjUj3/סאפים.jpg'
}, {
  icon: Coffee,
  title: 'מתקני כפר הנופש',
  description: 'בריכת שחייה וחוף מפנק',
  image: 'https://cdn.magicpatterns.com/uploads/hzvVTdRCydoPmYWgD5KmjT/1000327273.jpg'
}, {
  icon: Waves,
  title: 'טיול סאפים מודרך',
  description: 'חוויה מודרכת על מי הכנרת',
  image: 'https://cdn.magicpatterns.com/uploads/rMrufAv5CVsqC9RME1SMeN/image.png'
}, {
  icon: Heart,
  title: 'תרגול יוגה קבוצתי על הסאפ',
  description: 'שילוב מושלם של רוגע ואיזון',
  image: 'https://cdn.magicpatterns.com/uploads/1i37x3Y3o2Enq3mpME5bRw/יוגה.jpg'
}, {
  icon: Droplets,
  title: 'בריכת קרח',
  description: 'חוויה מרעננת ומחזקת',
  image: 'https://cdn.magicpatterns.com/uploads/sBpCmAgnydbLtGTXjGZ9we/thumbnail_IMG_2737.jpg'
}, {
  icon: Heart,
  title: 'מתחם עיסויים',
  description: 'מטפלים מקצועיים לרוגע מושלם',
  image: 'https://cdn.magicpatterns.com/uploads/ku2nCKD6NhCAd3mEmKjL3n/55D1CBB6-56A8-4025-9FEE-23F89E29A899.jpg'
}, {
  icon: Sparkles,
  title: 'כל דבר אחר שתחלמו עליו',
  description: 'אנחנו נבנה את האירוע המושלם עבורכם',
  image: 'https://cdn.magicpatterns.com/uploads/ozTxaeTJ3uPnJdnbNHjUnP/IMG_7518_(2).jpg'
}];
export function EventsPage() {
  const [formData, setFormData] = useState({
    fullName: '',
    phone: '',
    email: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleFormChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!formData.fullName.trim() || !formData.phone.trim()) return;
    setIsSubmitting(true);
    // Capture UTM params
    const utmParams = getUtmParams();
    // Track Meta Pixel event for Lead
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'Lead', {
        content_name: 'Events and Workshops',
        currency: 'ILS'
      });
    }
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSubmitted(true);
      // Redirect to WhatsApp after successful submission
      const text = encodeURIComponent(`היי, השארתי פרטים בדף אירועים וסדנאות.\nשם: ${formData.fullName}\nטלפון: ${formData.phone}`);
      window.open(`https://wa.me/972548800260?text=${text}`, '_blank');
    }, 1000);
  };
  useEffect(() => {
    // Set meta tags for Events page
    document.title = "אירועים וסדנאות | ביץ' קלאב מעגן";
    // Update or create meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', 'אירועים וסדנאות בכנרת - ימי גיבוש לחברות, אירועים משפחתיים, סדנאות קונספט. חוויה בלתי נשכחת על חוף הכנרת');
    // Open Graph tags
    const ogTags = [{
      property: 'og:title',
      content: "אירועים וסדנאות | ביץ' קלאב מעגן"
    }, {
      property: 'og:description',
      content: 'אירועים וסדנאות בכנרת - ימי גיבוש, אירועים משפחתיים וסדנאות מיוחדות על חוף הכנרת'
    }, {
      property: 'og:type',
      content: 'website'
    }];
    ogTags.forEach(tag => {
      let metaTag = document.querySelector(`meta[property="${tag.property}"]`);
      if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.setAttribute('property', tag.property);
        document.head.appendChild(metaTag);
      }
      metaTag.setAttribute('content', tag.content);
    });
  }, []);
  return <div className="min-h-screen bg-white" dir="rtl" data-id="element-1209" data-mp="2nvzbbl6uy57f">
      <UtmCapture data-id="element-1210" data-mp="2nxsid1ldurfy" />
      <Navigation data-id="element-1211" data-mp="2nu4rka7boj4x" />

      {/* Hero Section with Form */}
      <section className="relative min-h-[80vh] flex items-center pt-24 pb-12 overflow-hidden" id="hero-form" data-id="element-1212" data-mp="ucgv1dul1kd8">
        <div className="absolute inset-0 z-0" data-id="element-1213" data-mp="pexhkg5plbmc">
          <img src="https://cdn.magicpatterns.com/uploads/p194udREcU8JKLbaUPgaLY/GetAttachmentThumbnail_(3).jpg" alt="Events and Workshops" className="w-full h-full object-cover" data-id="element-1214" data-mp="knp49919d63w" />
          <div className="absolute inset-0 bg-gradient-to-l from-black/90 via-black/60 to-black/20" data-id="element-1215" data-mp="fmrqr9r7108q"></div>
        </div>

        <div className="container mx-auto px-4 relative z-10" data-id="element-1216" data-mp="6o60stje6ixx">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-1217" data-mp="6mmjczm021uk">
            {/* Text Content */}
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8
          }} className="text-white" data-id="element-1218" data-mp="1qxfwl6v00sz">
              <Calendar className="w-12 h-12 mb-6 text-blue-200" data-id="element-1219" data-mp="1r40yiz0ym3u7" />
              <h1 className="text-5xl md:text-7xl font-bold mb-4 leading-tight" data-id="element-1220" data-mp="1r1ogymz45vho">
                אירועים וסדנאות
              </h1>
              <p className="text-xl md:text-2xl max-w-2xl font-light mb-8" data-id="element-1221" data-mp="23m3nqrc865ml">
                חוויות בלתי נשכחות על מי הכנרת. ימי גיבוש, אירועים משפחתיים
                וסדנאות מיוחדות.
              </p>

              <div className="space-y-4 hidden md:block" data-id="element-1222" data-mp="2dcpv5y9sfpu7">
                <div className="flex items-center gap-3" data-id="element-1223" data-mp="2de9c7r39q4x1">
                  <CheckCircle2 className="w-6 h-6 text-cyan-400" data-id="element-1224" data-mp="1fphfijwgxb04" />
                  <span className="text-lg" data-id="element-1225" data-mp="1kniuasmv2o5s">התאמה אישית לכל קבוצה</span>
                </div>
                <div className="flex items-center gap-3" data-id="element-1226" data-mp="1pmlrjqwlnq37">
                  <CheckCircle2 className="w-6 h-6 text-cyan-400" data-id="element-1227" data-mp="1pl0y64m0ud6x" />
                  <span className="text-lg" data-id="element-1228" data-mp="1ulypb6p0ehkk">לוקיישן מושלם על המים</span>
                </div>
                <div className="flex items-center gap-3" data-id="element-1229" data-mp="312ag2mpi4x64">
                  <CheckCircle2 className="w-6 h-6 text-cyan-400" data-id="element-1230" data-mp="313v9g902ya2e" />
                  <span className="text-lg" data-id="element-1231" data-mp="35ziy8nanh17d">צוות מקצועי ומנוסה</span>
                </div>
              </div>
            </motion.div>

            {/* Lead Form */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="bg-white/10 backdrop-blur-md border border-white/20 p-8 rounded-3xl shadow-2xl max-w-md w-full mx-auto md:mx-0" data-id="element-1232" data-mp="3m6biw0dp6kzu">
              {isSubmitted ? <div className="text-center py-8" data-id="element-1233" data-mp="9oepqtkynyvx">
                  <div className="w-16 h-16 bg-emerald-500/20 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-1234" data-mp="9nmslebptt3j">
                    <CheckCircle2 className="w-8 h-8 text-emerald-400" data-id="element-1235" data-mp="nm39fy3akzze" />
                  </div>
                  <h3 className="text-2xl font-bold text-white mb-2" data-id="element-1236" data-mp="ipw4o8mmtuj1">
                    איזה כיף!
                  </h3>
                  <p className="text-gray-200" data-id="element-1237" data-mp="2kgfv1ajeg8me">
                    הפרטים התקבלו בהצלחה. נחזור אלייך בהקדם עם כל המידע.
                  </p>
                </div> : <>
                  <h3 className="text-2xl font-bold text-white mb-2 text-center" data-id="element-1238" data-mp="zz6ymjoa8ti9">
                    בואו נתכנן את האירוע שלכם
                  </h3>
                  <p className="text-gray-300 text-center mb-6 text-sm" data-id="element-1239" data-mp="q95c3wbkvj5g">
                    השאירו פרטים ונחזור אליכם לבניית אירוע מותאם אישית
                  </p>

                  <form onSubmit={handleSubmit} className="space-y-4" data-id="element-1240" data-mp="v5c8oyi33iaq">
                    <div data-id="element-1241" data-mp="h6cl7u6b59g5">
                      <input type="text" name="fullName" value={formData.fullName} onChange={handleFormChange} required placeholder="שם מלא" className="w-full bg-white/90 border-0 rounded-xl py-3 px-4 text-gray-900 placeholder:text-gray-500 focus:ring-2 focus:ring-cyan-400 transition-all" data-id="element-1242" data-mp="haa36ch5fuyg" />
                    </div>
                    <div data-id="element-1243" data-mp="21o0ofbmr58iu">
                      <input type="tel" name="phone" value={formData.phone} onChange={handleFormChange} required dir="ltr" placeholder="טלפון" className="w-full bg-white/90 border-0 rounded-xl py-3 px-4 text-gray-900 placeholder:text-gray-500 focus:ring-2 focus:ring-cyan-400 transition-all text-right" data-id="element-1244" data-mp="21otz2nou0i69" />
                    </div>
                    <div data-id="element-1245" data-mp="1i3grbj0rrtw0">
                      <input type="email" name="email" value={formData.email} onChange={handleFormChange} dir="ltr" placeholder="אימייל (אופציונלי)" className="w-full bg-white/90 border-0 rounded-xl py-3 px-4 text-gray-900 placeholder:text-gray-500 focus:ring-2 focus:ring-cyan-400 transition-all text-right" data-id="element-1246" data-mp="13d9jdx8e1t9k" />
                    </div>

                    <button type="submit" disabled={isSubmitting} className="w-full bg-gradient-to-r from-cyan-500 to-blue-500 hover:from-cyan-400 hover:to-blue-400 text-white font-bold py-4 rounded-xl transition-all shadow-lg flex items-center justify-center gap-2 mt-2" data-id="element-1247" data-mp="2119sogvqvvra">
                      {isSubmitting ? <div className="w-6 h-6 border-2 border-white/30 border-t-white rounded-full animate-spin" data-id="element-1248" data-mp="ao2jattacvm7"></div> : <>
                          <Send className="w-5 h-5" data-id="element-1249" data-mp="fogmnyjxzhdw" />
                          דברו איתי!
                        </>}
                    </button>
                  </form>
                </>}
            </motion.div>
          </div>
        </div>
      </section>

      <div className="container mx-auto px-4 py-20" data-id="element-1250" data-mp="32vurr5l8ztuq">
        {/* Introduction */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16 max-w-4xl mx-auto" data-id="element-1251" data-mp="32ts2inrx64r2">
          <h2 className="text-4xl md:text-5xl font-bold text-[#0A5F8F] mb-6" data-id="element-1252" data-mp="2663u4xhntqkp">
            אירועים לקבוצות וארגונים בכנרת לחוויה אחרת!
          </h2>
          <p className="text-xl text-gray-600 leading-relaxed" data-id="element-1253" data-mp="2jytn5lvlvvrb">
            מועדון ביץ' קלאב בכנרת מזמין אתכם לחוויה מיוחדת שתעצים, תגבש ותיתן
            לכם את האוויר והמרחב שאתם צריכים ליום מושלם ביחד.
          </p>
        </motion.div>

        {/* Our Events Section */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-1254" data-mp="1neb5ff9miris">
          <h2 className="text-4xl md:text-5xl font-bold text-[#0A5F8F] mb-4" data-id="element-1255" data-mp="3ri5pyhlmew8r">
            האירועים שלנו
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-1256" data-mp="51gt105xpl8">
            אנחנו מתאימים כל אירוע במיוחד עבורכם
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-20 max-w-7xl mx-auto" data-id="element-1257" data-mp="33li5egorn3su">
          {ourEvents.map((event, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 group" data-id="element-1258" data-mp="38l4h2loy4bzj" data-mpi={index}>
              <div className="relative h-64 overflow-hidden" data-id="element-1259" data-mp="xrs43ttxyaco">
                <div className={`absolute inset-0 bg-gradient-to-t ${event.color} opacity-20 z-10`} data-id="element-1260" data-mp="xu4mg83m2mq9" />
                <img src={event.image} alt={event.title} className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700" data-id="element-1261" data-mp="2ic5bc0x13jgg" />
              </div>

              <div className="p-8" data-id="element-1262" data-mp="28iogctl5nyb7">
                <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-1263" data-mp="23lpnsfh53zf4">
                  {event.title}
                </h3>

                <p className="text-gray-600 leading-relaxed mb-4" data-id="element-1264" data-mp="1ynefi96htwz0">
                  {event.description}
                </p>

                {event.link && <a href={event.link} className="inline-block text-[#0A5F8F] font-bold hover:text-cyan-600 transition-colors" data-id="element-1265" data-mp="1umum9gp1jdi5">
                    לפרטים נוספים ←
                  </a>}
              </div>
            </motion.div>)}
        </div>

        {/* What's Included Section */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-20" data-id="element-1266" data-mp="3jz67qf9wbaqz">
          <div className="text-center mb-12" data-id="element-1267" data-mp="2cnovt2kavn4c">
            <h2 className="text-4xl md:text-5xl font-bold text-[#0A5F8F] mb-4" data-id="element-1268" data-mp="2gosedwtqfx99">
              מה כלול באירוע?
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed" data-id="element-1269" data-mp="22pslue33my7t">
              <span className="font-bold text-[#0A5F8F]" data-id="element-1270" data-mp="27nkp249726rb">
                אנחנו בונים את האירוע במיוחד עבורכם!
              </span>
              <br data-id="element-1271" data-mp="1syehnt07da8c" />
              כל אירוע מותאם אישית לצרכי הלקוח והקבוצה
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-1272" data-mp="1xrhdk7sgcvrp">
            {eventIncludes.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-2xl border border-blue-100 overflow-hidden" data-id="element-1273" data-mp="1jweyov5mnw2r" data-mpi={index}>
                {item.image ? <div className="relative h-48 overflow-hidden" data-id="element-1274" data-mp="vfpombxbrlg9">
                    <img src={item.image} alt={item.title} className="w-full h-full object-cover" data-id="element-1275" data-mp="rdcvcmzrlg0d" />
                  </div> : <div className="p-6 pb-0" data-id="element-1276" data-mp="15cm26w22yxro">
                    <div className="bg-white w-12 h-12 rounded-xl flex items-center justify-center shadow-sm" data-id="element-1277" data-mp="10cpw8r9tow9h">
                      <item.icon className="w-6 h-6 text-[#0A5F8F]" data-id="element-1278" data-mp="1ec8yx4jv7fee" />
                    </div>
                  </div>}
                <div className="p-6" data-id="element-1279" data-mp="1abp4w9ul8rwh">
                  <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-1280" data-mp="1aanjpcjuyp11">
                    {item.title}
                  </h3>
                  <p className="text-gray-600 text-sm" data-id="element-1281" data-mp="1j37j4f7z4xmx">{item.description}</p>
                </div>
              </motion.div>)}
          </div>
        </motion.div>

        {/* Mid-page Lead Form */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-20 bg-gradient-to-br from-blue-50 to-cyan-50 border border-blue-100 rounded-3xl p-8 md:p-12 max-w-2xl mx-auto" data-id="element-1282" data-mp="1t1dlexxp05sb">
          <EventsLeadForm variant="light" title="מעוניינים בפרטים נוספים?" subtitle="השאירו פרטים ונחזור אליכם עם הצעה מותאמת אישית" data-id="element-1283" data-mp="2a2rifyvo4rzi" />
        </motion.div>

        {/* Custom Events CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-gradient-to-br from-[#0A5F8F] to-[#0D7AB8] rounded-3xl p-12 text-center text-white relative overflow-hidden" data-id="element-1284" data-mp="2evaw0vucvn4b">
          <div className="absolute inset-0 opacity-10" data-id="element-1285" data-mp="2sr6berpjqg2y">
            <div className="absolute inset-0" style={{
            backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
            backgroundSize: '40px 40px'
          }} data-id="element-1286" data-mp="2xrarigmjl8sn" />
          </div>

          <div className="relative z-10" data-id="element-1287" data-mp="13eulngxnrwob">
            <Sparkles className="w-16 h-16 mx-auto mb-6 text-blue-200" data-id="element-1288" data-mp="vujpwn2orp28" />
            <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-1289" data-mp="vwwj5wdw9lul">
              רוצים לארגן אירוע מיוחד?
            </h2>
            <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto" data-id="element-1290" data-mp="m508llumg39h">
              נשמח לעזור לכם לתכנן את האירוע המושלם - ימי גיבוש, חגיגות
              משפחתיות, סדנאות ועוד
            </p>
            <div className="max-w-md mx-auto bg-white/10 backdrop-blur-md border border-white/20 rounded-3xl p-8" data-id="element-1291" data-mp="1etnvflv0r0p5">
              <EventsLeadForm variant="dark" title="השאירו פרטים ונחזור אליכם" subtitle="נבנה יחד את האירוע המושלם עבורכם" data-id="element-1292" data-mp="19u1k5hyr3uiz" />
            </div>
          </div>
        </motion.div>
      </div>

      <ContactSection showTeam={false} data-id="element-1293" data-mp="zwnfefm6wu6i" />
      <Footer data-id="element-1294" data-mp="zvlqb78ca75s" />
    </div>;
}